module.exports = __webpack_public_path__ + "pc/img/banner.d97af42e.png";